import { IconButton, TextButton } from '@repo/ui';

type PowerOfAttorneyPreviewZoomControlsProps = {
  zoomScale: number;
  isMinZoom: boolean;
  isMaxZoom: boolean;
  onZoomOut: () => void;
  onZoomIn: () => void;
  onResetZoom: () => void;
};

export const PreviewZoomController = ({ zoomScale, isMinZoom, isMaxZoom, onZoomOut, onZoomIn, onResetZoom }: PowerOfAttorneyPreviewZoomControlsProps) => {
  return (
    <div className="fixed bottom-normal-large flex gap-[3px] items-center rounded-bzc-medium border border-neutral-border-low bg-neutral-background-dimmed-main p-tiny-large shadow-[0_4px_4px_rgba(0,0,0,0.08),0_0_8px_-4px_rgba(0,0,0,0.12)] backdrop-blur-sm">
      <IconButton
        key={`zoom-out-${isMinZoom}`}
        iconType={'minus'}
        size={'xsmall'}
        variant={'inverse'}
        type="button"
        className="rounded-bzc-circular disabled:cursor-not-allowed disabled:text-neutral-text-assistive"
        onClick={onZoomOut}
        disabled={isMinZoom}
        aria-label="축소"
      />
      <TextButton type="button" size={'xsmall'} variant={'inverse'} onClick={onResetZoom} aria-label="확대 비율 초기화">
        {Math.round(zoomScale * 100)}%
      </TextButton>
      <IconButton
        key={`zoom-in-${isMaxZoom}`}
        iconType={'plus'}
        size={'xsmall'}
        variant={'inverse'}
        type="button"
        className="rounded-bzc-circular disabled:cursor-not-allowed disabled:text-neutral-text-assistive"
        onClick={onZoomIn}
        disabled={isMaxZoom}
        aria-label="확대"
      />
    </div>
  );
};
